export function setUserState(field, value) {
  return {
    type: "SET_FIELD_USER",
    field: field,
    value: value,
  };
}
